import React from "react";
import { IonImg } from "@ionic/react";
import { useImageAssets } from "../../hooks/useImageAssets";

import "./FillerImage.css";

interface FillerImageProps {
  cssClass?: string;
}

const FillerImage: React.FC<FillerImageProps> = ({ cssClass }) => {
  const { imageAssetUrl } = useImageAssets("app/fillers");

  return (
    <div className={"filler-image " + cssClass}>
      <IonImg src={imageAssetUrl} />
    </div>
  );
};

export default FillerImage;
